import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CompanyGig, GigStatus } from "model/Gig";
import { Color } from "config/colors";
import { Api } from "services/api/api.service";
import { TimeReportStatus } from "model/TimeReport";
import { useAlertStore } from "stores/alertStore/alertStore";
import { ButtonStyled } from "components/buttons/buttons.styled";
import moment from "moment";
import { GigFormModal } from "../gigForm/gigFormModal.component";
import { CloseGigModal } from "../gigList/closeGigModal.component";

type Props = {
  gigData: CompanyGig;
  onGigClosed?: (gig: CompanyGig) => void;
  onGigUpdated?: (gig: CompanyGig) => void;
};

export const GigDetailButtons: React.FC<Props> = ({
  gigData,
  onGigClosed,
  onGigUpdated,
}) => {
  const { t } = useTranslation();
  const [, , alertDispatch] = useAlertStore();
  const [companyState] = useCompanyStore();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [showCreateGigModal, setShowCreateGigModal] = useState(false);
  const [cloneGig, setCloneGig] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "80%",
        margin: "0 auto",
      }}
    >
      {moment(gigData.shifts[gigData.shifts.length - 1].endTime).isAfter(
        moment()
      ) && (
        <>
          <ButtonStyled
            style={{ marginTop: 40 }}
            backgroundColor={Color.ModernGreen}
            onClick={() => {
              setCloneGig(false);
              setShowCreateGigModal(true);
            }}
          >
            {t("General.Edit")}
          </ButtonStyled>
        </>
      )}
      <ButtonStyled
        style={{ marginTop: 40 }}
        disabled={gigData.status === GigStatus.CLOSED}
        backgroundColor={Color.LighterDestructive}
        isCancel
        onClick={() => {
          if (companyState.company?.id) {
            Api()
              .company.timeReport.getGigTimeReports(
                companyState.company?.id,
                gigData.id
              )
              .then((res) => {
                if (
                  res.data.find(
                    (timeReport) => timeReport.status !== TimeReportStatus.NEW
                  )
                ) {
                  alertDispatch({
                    type: "SHOW_ALERT",
                    payload: {
                      icon: "alert",
                      title: "",
                      message: t("GigsCompany.ThisGigHasConnectedTimeReports"),
                    },
                  });
                } else {
                  setDeleteModalOpen(true);
                }
              });
          }
        }}
      >
        {t("General.Delete")}
      </ButtonStyled>
      <CloseGigModal
        modalOpen={deleteModalOpen}
        setModalOpen={setDeleteModalOpen}
        gigData={gigData}
        onGigClosed={onGigClosed}
      />
      {showCreateGigModal && (
        <GigFormModal
          gigData={gigData}
          showGigFormModal={showCreateGigModal}
          setShowGigFormModal={setShowCreateGigModal}
          onGigUpdated={onGigUpdated}
        />
      )}
    </div>
  );
};
